import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'semantic-ui-react';
import * as _ from 'lodash';
import shortid from 'shortid';
import PropTypes from 'prop-types';

import { setElementChanged } from 'State/dirtyTracking/actions';

class TrackedCheckboxContainer extends Component {
  componentDidMount() {
    this.id = shortid.generate();
  }

  onClick = (e, data) => {
    const { initialValue } = this.props;
    this.props.setElementChanged(this.id, initialValue, data.checked);
  };

  render() {
    const rest = _.omit(this.props, ['initialValue', 'setElementChanged']);

    return <Checkbox {...rest} onClick={this.onClick} />;
  }
}

TrackedCheckboxContainer.propTypes = {
  initialValue: PropTypes.bool,
};

const TrackedCheckbox = connect(null, {
  setElementChanged,
})(TrackedCheckboxContainer);

export { TrackedCheckbox };



// WEBPACK FOOTER //
// ./src/components/tracked/TrackedCheckbox.js